export const AppPermissions = {
  // Main permissions
  PortalAccess: ['TemplateApp.PortalAccess@TemplateApp'],
};
